import AddEvidenceDialog from './AddEvidenceDialog';
export default AddEvidenceDialog;